import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Chapter, Reveal, EASE } from "@/components/Reveal";
import { FAQS } from "@/data/content";

const Item = ({ faq, open, onToggle, index }) => (
  <div className="border-b border-white/10" data-testid={`faq-item-${index}`}>
    <button
      onClick={onToggle}
      className="w-full flex items-center justify-between gap-6 py-6 md:py-8 text-left group"
      data-testid={`faq-toggle-${index}`}
      aria-expanded={open}
    >
      <span className="font-heading text-lg md:text-2xl font-medium text-white group-hover:text-primary transition-colors duration-300">
        {faq.q}
      </span>
      <motion.span
        animate={{ rotate: open ? 45 : 0 }}
        transition={{ duration: 0.3, ease: EASE }}
        className="shrink-0 text-primary"
      >
        <Plus className="w-6 h-6" />
      </motion.span>
    </button>
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.4, ease: EASE }}
          className="overflow-hidden"
        >
          <p
            className="pb-8 pr-12 text-zinc-400 leading-relaxed text-sm md:text-base max-w-3xl"
            data-testid={`faq-answer-${index}`}
          >
            {faq.a}
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-24 md:py-32 border-t border-white/10" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-4">
          <Chapter num="Chapter 06" label="FAQ" />
          <h2 className="font-heading text-4xl sm:text-5xl tracking-tight leading-tight font-medium text-white">
            Questions, answered straight.
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-8">
          <div className="border-t border-white/10">
            {FAQS.map((f, i) => (
              <Item
                key={i}
                faq={f}
                index={i}
                open={open === i}
                onToggle={() => setOpen(open === i ? -1 : i)}
              />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
